import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

import Image from './Image';
import submit from './submit';
import validate from './validate';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import messages from '../../../../locale/jsonMessages';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock1.css';

const block1ActiveFields = ['hostBannerTitle1', 'hostBannerContent1', 'hostBannerContent2', 'buttonLabel', 'buttonLabel2'];

class WhyHostFormBlock1 extends Component {

  render() {
    const {
      error, handleSubmit, submitting,
      hostBannerloader, hostImageLoader,
      bannerImage, hostImage,
      selectedLanguage
    } = this.props;

    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminHeading'>
          <FormattedMessage {...messages.WhyBecomeOwnerBlock1} />
        </h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className="twoColumnGrid">
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}>
                  <FormattedMessage {...messages.ownerBanner} />
                </label>
                <Image
                  image={bannerImage}
                  fieldName={"hostBannerImage1"}
                  loader={hostBannerloader}
                />
              </div>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}>
                  <FormattedMessage {...messages.imageLabel} />
                </label>
                <Image
                  image={hostImage}
                  fieldName={"hostBannerImage2"}
                  loader={hostImageLoader}
                />
              </div>
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicWhyHostInfoBlock"
                component={FieldArrayComponent}
                activesFields={block1ActiveFields}
                filedName="dynamicWhyHostInfoBlock"
                selectedLanguage={selectedLanguage}
                label={formatMessage(messages.hostBannerTitle)}
                placeholder={formatMessage(messages.hostBannerTitle)}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

WhyHostFormBlock1 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock1);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  hostBannerloader: state.loader.hostBannerImage1,
  hostImageLoader: state.loader.hostBannerImage2,
  bannerImage: selector(state, 'hostBannerImage1'),
  hostImage: selector(state, 'hostBannerImage2'),
  selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, {}),
)(WhyHostFormBlock1);